// extracted by mini-css-extract-plugin
export default {"inputNumber":"InputNumber_inputNumber__Cv+vR","error":"InputNumber_error__iN2VO","selectWithError":"InputNumber_selectWithError__rfVr4"};